import OriginalNumberFormat, {
  type InputAttributes,
  type NumberFormatProps,
} from 'react-number-format';

/**
 * A wrapper component for react-number-format that resolves TypeScript type incompatibilities with React v19.
 * @param props - the original props of the react-number-format component
 */
export const NumberFormat = (props: NumberFormatProps) => {
  return <OriginalNumberFormat<InputAttributes> {...props} />;
};
